
<div class="nsw-container-fluid" id="app-container"> 
	<app-header></app-header>	
	<app-nav-menu></app-nav-menu>
	<main>		
		<router-outlet></router-outlet>
	</main>	
	<app-footer></app-footer>	
</div>

<app-loader *ngIf="loading" message="" #loader></app-loader>